import Vue from 'vue'

const trackedBillAgency = {
  state: {
    trackedBillAgencies: [],
    selectedTrackedBillAgency: {},
    saving: false,
    searchCount: 0,
  },

  getters: {
    trackedBillAgencies(state) {
      return state.trackedBillAgencies
    },
    selectedTrackedBillAgency(state) {
      return state.selectedTrackedBillAgency
    },
    loading(state) {
      return state.searchCount > 0
    },
  },

  mutations: {
    trackedBillAgencies(state, payload) {
      state.trackedBillAgencies = payload
    },
    selectedTrackedBillAgency(state, payload) {
      state.selectedTrackedBillAgency = JSON.parse(JSON.stringify(payload))
    },
    saving(state, payload) {
      state.saving = payload
    },
    searchCount(state, payload) {
      state.searchCount = payload
    },
    increaseSearchCount(state, payload) {
      state.searchCount = state.searchCount + 1
    },
    decreaseSearchCount(state, payload) {
      state.searchCount = state.searchCount - 1
    },
  },

  actions: {
    setSelectedTrackedBillAgency(context, payload) {
      context.commit('selectedTrackedBillAgency', payload)
    },
    loadTrackedBillAgencies(context, payload) {
      return new Promise((resolve, reject) => {
        const url = 'TrackedBillAgency'
        context.commit('increaseSearchCount')
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('trackedBillAgencies', res.data)
            context.commit('decreaseSearchCount')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('decreaseSearchCount')
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    loadTrackedBillAgenciesForBill(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `TrackedBillAgency/TrackedBill/${payload}`
        context.commit('increaseSearchCount')
        Vue.prototype.$axios.get(url).then(
          (res) => {
            // context.commit('trackedBillAgencies', res.data)
            context.commit('decreaseSearchCount')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('decreaseSearchCount')
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    refreshSelectedTrackedBillAgency(context, payload) {
      if (
        context.state.selectedTrackedBillAgency &&
        context.state.selectedTrackedBillAgency.ID
      ) {
        context.dispatch(
          'loadSelectedTrackedBillAgency',
          context.state.selectedTrackedBillAgency.ID
        )
      }
    },
    loadSelectedTrackedBillAgency(context, payload) {
      if (
        context.state.selectedTrackedBillAgency &&
        context.state.selectedTrackedBillAgency.ID != payload
      ) {
        context.commit('selectedTrackedBillAgency', {})
      }
      return new Promise((resolve, reject) => {
        const url = 'TrackedBillAgency/' + payload
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('selectedTrackedBillAgency', res.data)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    clearLookupCacheAndReloadTrackedBillAgencies(context, payload) {
      caches.delete('apilookup-cache').finally(() => {
        context.dispatch('loadTrackedBillAgencies')
      })
    },
    updateTrackedBillAgency(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `TrackedBillAgency/${payload.ID}`
        context.commit('saving', true)
        Vue.prototype.$axios.put(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              { color: 'success', message: 'tracked bill agency updated' },
              { root: true }
            )
            //if you will always need to reload the list after an update
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadTrackedBillAgencies')
            context.commit('saving', false)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('saving', false)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    createTrackedBillAgency(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `TrackedBillAgency`
        context.commit('saving', true)
        Vue.prototype.$axios.post(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              { color: 'success', message: 'tracked bill agency created' },
              { root: true }
            )
            //if you will always need to reload the list after an item is created
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadTrackedBillAgencies')
            context.commit('saving', false)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('saving', false)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    saveTrackedBillAgency(context, payload) {
      return new Promise((resolve, reject) => {
        if (payload.ID > 0) {
          context.dispatch('updateTrackedBillAgency', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        } else {
          context.dispatch('createTrackedBillAgency', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        }
      })
    },
    deleteTrackedBillAgency(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `TrackedBillAgency/${payload.ID}`
        Vue.prototype.$axios.delete(url).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              { color: 'success', message: 'tracked bill agency deleted' },
              { root: true }
            )
            //if you will always need to reload the list after a delete
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadTrackedBillAgencies')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
  },
}

export default trackedBillAgency
